/* @flow */

const getSelectPorId = (id: string): HTMLSelectElement => {
    const select = document.getElementById(id);
    if (!select) {
        throw new TypeError(`#${id} não encontrado no documento.`);
    }

    if (select instanceof HTMLSelectElement) {
        return select;
    }

    throw new TypeError(`#${id} não é um select.`);
};

export default getSelectPorId;
